import request from '../config/request'


export const RETMSignInAPI = async (body: any) => {
  const response = await request({
    url: `/app/provider/retm/signin`,
    body: body,
    method: 'POST',
    customURl: true,
  });

  return response
}

export const RETMOtpVerificationAPI = async (body: any) => {
  const response = await request({
    url: `/app/provider/retm/otp-verification`,
    body: body,
    method: 'POST',
    customURl: true,
  });

  return response
}

export const RETMResendOTP = async (body: any) => {
  const response = await request({
    url: `/app/provider/retm/otp-verification`,
    body: body,
    method: 'POST',
    customURl: true,
  });

  return response
}
